module.exports = "/assets/2dU_ZPKXYI.png";